/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable import/no-duplicates */ 
/* eslint-disable arrow-parens */ 
/* eslint-disable no-confusing-arrow */ 
/* eslint-disable no-nested-ternary */ 
/* eslint-disable no-plusplus */ 
/* eslint-disable implicit-arrow-linebreak */ 
/* eslint-disable function-paren-newline */ 
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import * as ActionTypes from 'src/store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Col } from 'src/components/Col';
import { RangeDatePicker } from 'src/components/datepicker';
import Layout from 'src/components/layout';
import { Row } from 'src/components/Row';
import moment from 'moment';
import { Polygon } from '../Sandbox/types';
import { Image, Layer, Line, Stage } from 'react-konva';
import useImage from 'use-image';
import { Card } from 'src/components/Card';
import { Table } from 'src/components/Table';
import { pointsToFlatArray, denormalizePolygonPoints } from '../Sandbox/utils/coordinateUtils';
import { fetchPolygonMetrics } from '../Sandbox/services/api';
import { BusiestDayRow } from '../Sandbox/types';
import { getTimestampOf } from 'src/utils/helpers';
import PerformanceGraph from 'src/components/PerformanceGraph/PerformanceGraph';
import { cameraPerformanceCSVDownload, cameraPerformancePlotData, cameraPerformancePlotLayout } from '../Cameras/utils/performance.util';
import PerformancePlot from 'src/components/PerformanceGraph/PerformancePlot';
import AreaIndicators from './AreaIndicators';
import AreaHeatmapCalendar from './AreaHeatmapCalendar';
import CameraHeatmaps from '../Cameras/components/CameraHeatmaps';
import { Toggle } from 'src/components/Toggle';
import { PlotHeatmap } from 'src/components/PlotHeatmap';
import { Icon } from 'src/components/Icon';
import { Tooltip } from 'src/components/Tooltip';
import { useModal } from 'src/hooks/useModal';
import { DownloadCSV } from 'src/components/DownloadCSV';
import { Modal } from 'src/components/Modal';
import HeatMapCalendarBusiestPeriodPlot from '../StoreDetail/heatMapCalendarBusiestPeriodPlot';

const CANVAS_WIDTH = 550;
const CANVAS_HEIGHT = 350;

interface IUseParamsPolygon {
  storeId: string,
  departmentId: string,
  cameraId: string,
  areaId: string,
}

// interface GraphDataType {
//   graphData: Array<{
//     name: string;
//     data: number[];
//   }>;
//   categories: string[];
// }

const AreaView: React.FC<{
  imageBackground: string;
  polygon: Polygon | undefined;
  showHeatmap: boolean;
  heatmapData?: any;
  onToggleHeatmap: (value: boolean) => void;
}> = ({
  imageBackground,
  polygon,
  showHeatmap,
  heatmapData,
  onToggleHeatmap,
}) => {
  const [image] = useImage(imageBackground || '');
  const points = denormalizePolygonPoints(polygon?.points || [], CANVAS_WIDTH, CANVAS_HEIGHT);
  const pointsFlat = pointsToFlatArray(points);

  const processedHeatmapData = useMemo(() => {
    if (!heatmapData || !showHeatmap) return [];

    let heatmapArray = [];
    let maxValue = 0;
    
    if (heatmapData.get_heatmap?.heatmap) {
      heatmapArray = heatmapData.get_heatmap.heatmap;
      maxValue = heatmapData.get_heatmap.max_value || 0;
    } else if (heatmapData.heatmap) {
      heatmapArray = heatmapData.heatmap;
      maxValue = heatmapData.max_value || 0;
    }

    return heatmapArray.map((row: any[]) => 
      row.map((cell: any) => {
        if (typeof cell === 'number') return cell;
        return cell.value || cell.total_time || cell.average_time || 0;
      })
    );
  }, [heatmapData, showHeatmap]);

  return (
    <Card 
      title="Area View" 
      className="pl-4 pb-4"
      headerRight={
        (
          <div className="flex items-center gap-2">
            <span className="text-sm">Heatmap</span>
            <Toggle 
              checked={showHeatmap} 
              onChange={onToggleHeatmap} 
              disabled={!heatmapData}
            />
          </div>
        )
      }
    >
      <div style={{ width: CANVAS_WIDTH, height: CANVAS_HEIGHT, position: 'relative' }}>
        {showHeatmap && (
          <PlotHeatmap
            data={processedHeatmapData}
            imageSrc={imageBackground}
            type="footfall"
            height={CANVAS_HEIGHT}
            width={CANVAS_WIDTH}
          />
        )}
        <div style={{ width: CANVAS_WIDTH, height: CANVAS_HEIGHT, position: 'absolute', top: 0, left: 0 }}>
          <Stage width={CANVAS_WIDTH} height={CANVAS_HEIGHT}>
            {!showHeatmap && (
              <Layer>
                <Image image={image} width={CANVAS_WIDTH} height={CANVAS_HEIGHT} opacity={0.5} />
              </Layer>
            )}
            <Layer>
              {polygon && (
                <Line
                  points={pointsFlat}
                  closed
                  fill="rgba(59, 130, 246, 0.4)"
                  stroke="#2563eb"
                  strokeWidth={2}
                />
              )}
            </Layer>
          </Stage>
        </div>
      </div>
    </Card>
  );
};

const Areas: React.FC = () => {
  const dispatch = useDispatch();
  const { storeId, departmentId, cameraId, areaId } = useParams<IUseParamsPolygon>();
  const { polygon, polygonLoading } = useSelector((state: any) => state.polygons);
  const { cameraImage, cameraImageLoading } = useSelector((state: any) => state.cameras);
  const { startDate, endDate } = useSelector((state: any) => state.dateTime);
  const { interval, allCameraGraphsLoading } = useSelector((state: any) => state.graphs);
  const { polygon_calendar_heatmap_loading, heatmap, loading: heatmapLoading } = useSelector((state: any) => state.heatmap);
  const { areaDetailsLoading } = useSelector((state: any) => state.areas);
  const [heatmapDownloadCSV, setHeatmapDownloadCSV] = useState([]);
  const [isOpen, onClose, onOpen] = useModal();
  const startTimeTimestamp = Math.trunc(getTimestampOf(new Date(startDate)));
  const endTimeTimestamp = Math.trunc(getTimestampOf(new Date(endDate)));
  const intervalLabel = `${moment(startDate).format('DD/MM/YYYY HH:mm')} - ${moment(endDate).format('DD/MM/YYYY HH:mm')}`;

  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [headerData, setHeaderData] = useState<{ title: string, subtitle: string }>({
    title: '',
    subtitle: '',
  });
  const [mappedPolygon, setMappedPolygon] = useState<Polygon>();
  const [busiestDays, setBusiestDays] = useState<BusiestDayRow[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showHeatmap, setShowHeatmap] = useState(false);
  
  const handleIntervalChange = useCallback((newInterval: string) => {
    dispatch(
      ActionTypes.getAllCameraGraphs.request({
        storeId,
        departmentId,
        cameraId,
        startDate: startTimeTimestamp,
        endDate: endTimeTimestamp,
        interval: newInterval,
        polygonId: areaId,
        genderFilter: undefined,
        ageFilter: undefined,
      }),
    );
  }, [dispatch, storeId, departmentId, cameraId, startTimeTimestamp, endTimeTimestamp, areaId]);

  // const graphData = useMemo<GraphDataType>(() => {
  //   if (!busiestDays.length) return { graphData: [], categories: [] };

  //   const convertTimeToSeconds = (timeStr: string) => {
  //     if (!timeStr || timeStr === '-') return 0;
  //     const [minutes, seconds] = timeStr.split(':').map(Number);
  //     return minutes * 60 + seconds;
  //   };

  //   const validDays = busiestDays.filter(day => day.date && day.date !== '-');
    
  //   const categories = validDays.map(day => moment(day.date).unix().toString());
    
  //   const footfallData = {
  //     name: 'cam_total_footfall_graph',
  //     data: validDays.map(day => typeof day.unique_visitors === 'number' ? day.unique_visitors : 0)
  //   };
    
  //   const avgTimeData = {
  //     name: 'cam_average_time_graph',
  //     data: validDays.map(day => convertTimeToSeconds(day.avg_time_spent_seconds || ''))
  //   };

  //   return {
  //     graphData: [footfallData, avgTimeData],
  //     categories
  //   };
  // }, [busiestDays]);

  const fetchData = useCallback(async () => {
    if (!polygon || !polygon.coordinates || polygon.coordinates.length < 4) {
      return;
    }

    setIsLoading(true);
    try {
      const formValues = {
        x1: polygon.coordinates[0].x.toFixed(4),
        y1: polygon.coordinates[0].y.toFixed(4),
        x2: polygon.coordinates[1].x.toFixed(4),
        y2: polygon.coordinates[1].y.toFixed(4),
        x3: polygon.coordinates[2].x.toFixed(4),
        y3: polygon.coordinates[2].y.toFixed(4),
        x4: polygon.coordinates[3].x.toFixed(4),
        y4: polygon.coordinates[3].y.toFixed(4),
      };

      const response = await fetchPolygonMetrics(
        formValues,
        startTimeTimestamp,
        endTimeTimestamp,
        parseInt(departmentId, 10),
        parseInt(cameraId, 10),
        parseInt(storeId, 10)
      );
      
      setBusiestDays(response.busiestDays);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [polygon, startTimeTimestamp, endTimeTimestamp, departmentId, cameraId, storeId]);

  useEffect(() => {
    if (polygon && polygon.coordinates && polygon.coordinates.length > 0) {
      const points = polygon.coordinates.map((point: any) => ({
        x: point.x,
        y: point.y,
      }));
      setMappedPolygon({
        id: polygon.id,
        name: polygon.name,
        points,
        isSelected: false,
      });

      setHeaderData({
        title: polygon.name.charAt(0).toUpperCase() + polygon.name.slice(1),
        subtitle: `Created: ${moment(polygon.created_at).format('YYYY-MM-DD HH:mm')}`,
      });
    }
    if (cameraId) {
      dispatch(ActionTypes.getCameraImage.request({ cameraId }));
    }
  }, [polygon, cameraId, dispatch]);

  useEffect(() => {
    dispatch(ActionTypes.getPolygon.request({ areaId }));
    dispatch(ActionTypes.getPolygonCalendarHeatmap.request({
      storeId,
      startDate: startTimeTimestamp,
      endDate: endTimeTimestamp,
      areaId,
    }));
    dispatch(
      ActionTypes.getAllCameraGraphs.request({
        storeId,
        departmentId,
        cameraId,
        startDate: startTimeTimestamp,
        endDate: endTimeTimestamp,
        interval,
        polygonId: areaId,
        genderFilter: undefined,
        ageFilter: undefined,
      }),
    );
    dispatch(ActionTypes.getHeatmap.request({
      cameraId,
      startDate: startTimeTimestamp,
      endDate: endTimeTimestamp,
      genderFilter: undefined,
      ageFilter: undefined,
      areaId,
    }));
  }, [dispatch, areaId, storeId, departmentId, cameraId, startTimeTimestamp, endTimeTimestamp, interval]);

  useEffect(() => {
    if (polygon && startTimeTimestamp && endTimeTimestamp) {
      fetchData();
    }
  }, [polygon, startTimeTimestamp, endTimeTimestamp, fetchData]);

  useEffect(() => {
    if (busiestDays.length > 0) {
      const totalFootfall = busiestDays.reduce((sum, day) => {
        const visitors = typeof day.unique_visitors === 'number' ? day.unique_visitors : 0;
        return sum + visitors;
      }, 0);

      let totalTimeInSeconds = 0;
      let validDaysCount = 0;
      
      busiestDays.forEach(day => {
        if (day.avg_time_spent_seconds && day.avg_time_spent_seconds !== '-') {
          const [minutes, seconds] = day.avg_time_spent_seconds.split(':').map(Number);
          totalTimeInSeconds += (minutes * 60 + seconds);
          validDaysCount++;
        }
      });
      
      const avgTimeInSeconds = validDaysCount > 0 ? totalTimeInSeconds / validDaysCount : 0;

      dispatch(ActionTypes.getAreaDetails.success([{
        footfall_metrics: totalFootfall,
        time_metrics: {
          average_time: avgTimeInSeconds
        }
      }]));
    }
  }, [busiestDays, dispatch]);

  const handleZoomEvent = (eventdata: any) => {
    const startDateStr = eventdata['xaxis.range[0]'];
    const endDateStr = eventdata['xaxis.range[1]'];

    if (!startDateStr || !endDateStr) {
      return;
    }

    const startMoment = moment(startDateStr);
    const endMoment = moment(endDateStr);

    const startUnix = startMoment.valueOf();
    const endUnix = endMoment.valueOf();

    console.log(`start_date: ${startMoment}, end_date: ${endMoment}`);
    if ((startUnix && endUnix) && startUnix < endUnix) {
      dispatch(ActionTypes.updateLastStartDate(startDate));
      dispatch(ActionTypes.updateLastEndDate(endDate));
      dispatch(ActionTypes.updateStartDate(startMoment));
      dispatch(ActionTypes.updateEndDate(endMoment));
    }
  };

  return (
    <Layout
      title={headerData.title}
      subtitle={headerData.subtitle}
      loading={polygonLoading || cameraImageLoading || polygon_calendar_heatmap_loading || areaDetailsLoading || heatmapLoading}
    >
      <Row>
        <Col className="flex flex-row pb-2 relative">
          <RangeDatePicker needTime />
        </Col>
      </Row>
      <Row>
        <Col>
          <AreaIndicators />
          <PerformanceGraph
            intervalLabel={intervalLabel}
            performanceDataCSV={cameraPerformanceCSVDownload}
            performancePlotData={cameraPerformancePlotData}
            performancePlotLayout={cameraPerformancePlotLayout}
            type="camera"
            title="Area Performance"
            loading={allCameraGraphsLoading}
            onIntervalChange={handleIntervalChange}
            onRelayout={handleZoomEvent}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          {cameraImage && (
            <AreaView 
              imageBackground={cameraImage} 
              polygon={mappedPolygon} 
              showHeatmap={showHeatmap} 
              heatmapData={heatmap}
              onToggleHeatmap={setShowHeatmap}
            />
          )}
        </Col>
        <Col>
          <Card
            className="w-full"
            title="Busiest Period"
            iconsGroup={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <div className="flex gap-5">
                <Tooltip tooltipText="Busiest Period" tooltipPlacement="top">
                  <Icon className="text-xl" tag="button" onClick={onOpen} icon="fullScreen" />
                </Tooltip>
                <Tooltip tooltipText="Download" tooltipPlacement="top">
                  {heatmapDownloadCSV && (
                    <DownloadCSV filename={`Average Queue Length - ${intervalLabel}`} data={heatmapDownloadCSV}>
                      <Icon icon="download" className="text-xl" />
                    </DownloadCSV>
                  )}
                </Tooltip>
              </div>
            }
          >
            <AreaHeatmapCalendar
              height={365}
              className="custom-heatmap"
              setHeatmapDownloadCSV={setHeatmapDownloadCSV}
              isHeatmapTotal
            />
          </Card>
        </Col>
      </Row>
      {/* <Row>
        <Col>
          <Card title="Area Performance">
            {isLoading ? (
              <div className="flex justify-center items-center h-full">
                <p>Loading data...</p>
              </div>
            ) : busiestDays.length > 0 ? (
              <PerformancePlot
                categories={graphData.categories}
                graphData={graphData.graphData}
                performancePlotData={cameraPerformancePlotData}
                performancePlotLayout={cameraPerformancePlotLayout}
                graphsPrefix="cam"
              />
            ) : (
              <div className="flex justify-center items-center py-8">
                <p>No data available for this time period</p>
              </div>
            )}
          </Card>
        </Col>
      </Row> */}
      <Modal className="p-6" size="xl" isOpen={isOpen} onClose={onClose} title="Busiest Period" subTitle="Average Queue Length between 11:30 and 15:30 on weekdays">
        <HeatMapCalendarBusiestPeriodPlot
          isHeatmapTotal={false}
          setHeatmapDownloadCSV={setHeatmapDownloadCSV}
          className="custom-heatmap"
        />
      </Modal>
    </Layout>
  );
};

export default Areas;
